export const config = {
  urlBefore: process.env.REACT_APP_URL_BEFORE,
  urlAfter: '.html',
  pages: [
    {
      id: process.env.REACT_APP_HOME_ID,
    },
    {
      id: process.env.REACT_APP_KYRGYZSTAN_ID,
      label: 'Кыргызстан',
    },
    {
      id: process.env.REACT_APP_KAZAKHSTAN_ID,
      label: 'Казахстан',
    },
    {
      id: process.env.REACT_APP_TAJIKISTAN_ID,
      label: 'Таджикистан',
    },
    {
      id: process.env.REACT_APP_KAZAKHSTAN_2_ID,
      label: 'Казахстан',
    },
    {
      id: process.env.REACT_APP_UZBEKISTAN_ID,
      label: 'Узбекистан',
    },
  ],
}
